var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full mt-4"},[_c('EuiGridRow',[_c('EuiHeading',{staticClass:"flex w-full",attrs:{"level":3}},[_c('div',[_vm._v(" Le "+_vm._s(_vm.localeToDisplay))])])],1),_c('EuiGridRow',[_c('traceArea',{attrs:{"id":`${_vm.content._id}`,"message":_vm.content.message,"error":_vm.content.has_error,"rows":10}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }